/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Listing_Empty_Corpus_KeptInputs */



/**
* | output |
* | --- |
* | "The source returned no content in the last sync while documents are already indexed — nothing was deleted. Check this connection's scope and permissions." |
*
* @param {Sync_Degraded_Listing_Empty_Corpus_KeptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_listing_empty_corpus_kept = /** @type {((inputs?: Sync_Degraded_Listing_Empty_Corpus_KeptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Listing_Empty_Corpus_KeptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Quelle hat bei der letzten Synchronisierung keine Inhalte geliefert, obwohl bereits Dokumente indexiert sind — es wurde nichts gelöscht. Bitte Umfang und Berechtigungen dieser Verbindung prüfen.")
	return /** @type {LocalizedString} */ ("The source returned no content in the last sync while documents are already indexed — nothing was deleted. Check this connection's scope and permissions.")
});